// extracted by mini-css-extract-plugin
export default {"NextBtn":"Carousel_NextBtn__GC1vk","Dots":"Carousel_Dots__SKWFI","DotsFocus":"Carousel_DotsFocus__5ATUF"};